/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var PENDING_SELECTOR = '.product-item__price-list.price-list--wpd-pending, .product-form__price-list.price-list--wpd-pending, .variant-swatch__price-list.price-list--wpd-pending';
  var FALLBACK_MS = 2000;
  var BOUND_ATTRIBUTE = 'data-wpd-pending-bound';

  function reveal(listEl) {
    if (!listEl || !listEl.classList || !listEl.classList.contains('price-list--wpd-pending')) return;
    listEl.classList.remove('price-list--wpd-pending');
  }

  function attachReveal(pendingLists) {
    pendingLists.forEach(function (listEl) {
      if (!listEl || listEl.hasAttribute(BOUND_ATTRIBUTE)) return;

      listEl.setAttribute(BOUND_ATTRIBUTE, 'true');

      var priceEl = listEl.querySelector('.price:not(.price--compare)');
      var done = false;
      function runReveal() {
        if (done) return;
        done = true;
        reveal(listEl);
      }
      if (priceEl) {
        var obs = new MutationObserver(runReveal);
        obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
      }
      setTimeout(runReveal, FALLBACK_MS);
    });
  }

  function bindPendingPriceReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    attachReveal(scope.querySelectorAll(PENDING_SELECTOR));
  }

  function init() {
    bindPendingPriceReveal(document);
    document.addEventListener('product:rerender', function () {
      requestAnimationFrame(function () {
        bindPendingPriceReveal(document);
      });
    });
    document.addEventListener('shopify:section:load', function (ev) {
      var root = ev.target && ev.target.querySelector ? ev.target : document;
      bindPendingPriceReveal(root);
    });
    document.addEventListener('theme:loading:end', function () {
      requestAnimationFrame(function () {
        bindPendingPriceReveal(document);
      });
    });
    var placeholder = document.querySelector('.recently-viewed-products-placeholder');
    if (placeholder) {
      var placeObs = new MutationObserver(function () {
        bindPendingPriceReveal(placeholder);
      });
      placeObs.observe(placeholder, { childList: true, subtree: true });
    }
    document.querySelectorAll('.product-recommendations').forEach(function (container) {
      var recommendationsObs = new MutationObserver(function () {
        bindPendingPriceReveal(container);
      });
      recommendationsObs.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
